import { type RouteObject } from 'react-router';
import { RoutesList } from '../../config/routes-list';
import MainLayout from '../../layouts/MainLayout';
import { lazyRoute } from '../lazy-route';

export const notificationsRoutes: RouteObject[] = [
  {
    path: RoutesList.NOTIFICATIONS,
    element: <MainLayout />,
    children: [
      {
        index: true,
        ...lazyRoute(() => import('../../pages/notifications/notifications-page')),
      },
    ],
  },
];
